import { ActionType } from "../types";
import { Directory, DirectoryAction } from "../types/directory";

export function directory(
  state: Directory = {},
  action: DirectoryAction
): Directory {
  switch (action.type) {
    case ActionType.GET_DIRECTORY_REQUEST:
      return {
        ...state,
        [action.search]: null,
      };
    case ActionType.GET_DIRECTORY_SUCCESS:
      return {
        ...state,
        [action.search]: action.users,
      };
    case ActionType.GET_DIRECTORY_FAILURE:
      return {
        ...state,
        [action.search]: null,
      };
    default:
      return state;
  }
}
